import React, { useState, useRef } from "react";
import { CircularProgress, Grid2, Snackbar } from "@mui/material";
import styles from "./CredentialsDropdown.module.scss";
import { ReactComponent as WordPress } from "../../GlobalAssets/svg/Wordpress.svg";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import CopyAllOutlinedIcon from "@mui/icons-material/CopyAllOutlined";
import { getStore } from "../../Utils/storeUtils";
import { Actions } from "../../redux/constants/actionTypes";

const CredentialsDropdown = ({
  title,
  username = "Nikhil",
  password,
  siteName,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const toggleShowPassword = () => {
    if (showPassword) {
      // If already showing, just hide it
      setShowPassword(false);
      return;
    }

    // Start loading when revealing password
    setIsLoading(true);

    getStore().dispatch({
      type: Actions.API_GET_INSTANCE_PASSWORD,
      data: {
        instanceName: siteName,
      },
      meta: {
        onSuccess: () => {
          setIsLoading(false);
          setShowPassword(true); // show after password fetched
        },
        onError: () => {
          setIsLoading(false);
        },
      },
    });
  };

  const copyToClipboard = (text) => {
    setSnackbarOpen(true);
    navigator.clipboard.writeText(text);
  };

  return (
    <Grid2 className={styles.credentialsDropdown}>
      <Grid2
        className={`${styles.dropdownHeader} ${isOpen ? styles.isOpen : ""}`}
        onClick={toggleDropdown}
      >
        <WordPress className={styles.iconColor} /> {title}
        {isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </Grid2>
      <Grid2 className={isOpen ? styles.isOpenbg : ""} />

      {isOpen && (
        <Grid2 className={styles.dropdownContent}>
          <Grid2 className={styles.displayFlex}>
            <Grid2 className={styles.usertext}>
              User Name : <span className={styles.userName}>{username}</span>
            </Grid2>
            <CopyAllOutlinedIcon
              className={styles.colorIcon}
              onClick={() => copyToClipboard(username)}
            />
          </Grid2>
          <Grid2 className={styles.displayFlex}>
            <Grid2 className={styles.usertext}>
              Password : {" "}
              <span className={styles.userName}>
                {isLoading ? (
                  <CircularProgress size={10} color="inherit" />
                ) : showPassword ? (
                  password
                ) : (
                  "************"
                )}
              </span>{" "}
              <span className={styles.showText} onClick={toggleShowPassword}>
                {!isLoading && (showPassword ? "hide" : "show")}
              </span>
            </Grid2>
            {showPassword && (
              <CopyAllOutlinedIcon
                className={styles.colorIcon}
                onClick={() => copyToClipboard(password)}
              />
            )}
          </Grid2>
        </Grid2>
      )}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={() => setSnackbarOpen(false)}
        message="Copied to clipboard"
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      />
    </Grid2>
  );
};

export default CredentialsDropdown;
